module.exports = __webpack_public_path__ + "assets/img/5_1340_big.0af47cb2.jpg";